import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import * as marked from 'marked';


@Injectable({
  providedIn: 'root'
})
export class MarkdownRenderService {
  constructor(
    private domSanitizer: DomSanitizer,
  ) {}

  public getRenderedMarkdown(content: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked(
        content,
        {
          breaks: true
        }
      )
    );
  }

  public getRenderedInlineMarkdown(content: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked.parseInline(
        content,
        {
          breaks: true
        }
      )
    );
  }
}
